import { faClock, faCalendarDay, faPlay, faChartBar, faHourglass2 } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getUkrainianPlural } from 'helpers/getUkrainianPlural';
import { formatDate } from 'helpers/formatDate';
import styles from './WorkTimeStats.scss';

export const WorkTimeStats = ({ data, activeSession, dateRange }) => {
  const formatDuration = (minutes) => {
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    return `${hours}г ${mins}хв`;
  };

  const formatHoursDecimal = (decimal) => {
    return `${parseFloat(decimal).toFixed(2)} год`;
  };

  const calculateCurrentSessionTime = () => {
    if (!activeSession) return 0;
    const now = new Date();
    const loginTime = new Date(activeSession.loginTime);
    return Math.floor((now - loginTime) / (1000 * 60));
  };

  const currentSessionMinutes = calculateCurrentSessionTime();
  const totalWithCurrent = data.totalMinutes + currentSessionMinutes;

  const getDaysInPeriod = () => {
    const timeDiff = dateRange.endDate.getTime() - dateRange.startDate.getTime();
    return Math.ceil(timeDiff / (1000 * 3600 * 24)) + 1;
  };

  const averagePerDay = totalWithCurrent / getDaysInPeriod();

  return (
    <div className={styles.statsContainer}>
      <div className={styles.statsGrid}>
        <div className={styles.statCard}>
          <div className={styles.statIcon}>
            <FontAwesomeIcon icon={faClock} />
          </div>
          <div className={styles.statContent}>
            <h3>Загальний час</h3>
            <div className={styles.statValue}>{formatDuration(totalWithCurrent)}</div>
            <div className={styles.statSubtext}>{formatHoursDecimal(totalWithCurrent / 60)}</div>
          </div>
        </div>

        <div className={styles.statCard}>
          <div className={styles.statIcon}>
            <FontAwesomeIcon icon={faCalendarDay} />
          </div>
          <div className={styles.statContent}>
            <h3>Кількість сесій</h3>
            <div className={styles.statValue}>
              {data.sessionsCount}
              {activeSession && <span className={styles.activeBadge}>+1</span>}
            </div>
            <div className={styles.statSubtext}>завершено</div>
          </div>
        </div>

        <div className={styles.statCard}>
          <div className={styles.statIcon}>
            <FontAwesomeIcon icon={faChartBar} />
          </div>
          <div className={styles.statContent}>
            <h3>Середньо за день</h3>
            <div className={styles.statValue}>{formatDuration(Math.round(averagePerDay))}</div>
            <div className={styles.statSubtext}>
              за {getDaysInPeriod()} {getUkrainianPlural(getDaysInPeriod(), ['день', 'дні', 'днів'])}
            </div>
          </div>
        </div>

        {activeSession && (
          <div className={styles.statCard}>
            <div className={`${styles.statIcon} ${styles.active}`}>
              <FontAwesomeIcon icon={faPlay} />
            </div>
            <div className={styles.statContent}>
              <h3>Поточна сесія</h3>
              <div className={styles.statValue}>{formatDuration(currentSessionMinutes)}</div>
              <div className={styles.statSubtext}>
                з{' '}
                {new Date(activeSession.loginTime).toLocaleTimeString('uk-UA', {
                  hour: '2-digit',
                  minute: '2-digit',
                })}
              </div>
            </div>
          </div>
        )}
      </div>

      {Object.keys(data.workingDays).length > 0 && (
        <div className={styles.dailyStats}>
          <h3>
            <FontAwesomeIcon icon={faHourglass2} />
            Робочі дні за період
          </h3>
          <div className={styles.dailyGrid}>
            {Object.entries(data.workingDays)
              .sort(([a], [b]) => new Date(b) - new Date(a))
              .map(([date, minutes]) => (
                <div key={date} className={styles.dailyItem}>
                  <div className={styles.dailyDate}>{formatDate(date, 'UA')}</div>
                  <div className={styles.dailyTime}>{formatDuration(minutes)}</div>
                  <div className={styles.dailyBar}>
                    <div
                      className={styles.dailyBarFill}
                      style={{
                        width: `${Math.min((minutes / (12 * 60)) * 100, 100)}%`,
                      }}
                    />
                  </div>
                </div>
              ))}
          </div>
        </div>
      )}

      <div className={styles.periodInfo}>
        <h4>Період аналізу:</h4>
        <p>
          з {formatDate(dateRange.startDate, 'UA')} по {formatDate(dateRange.endDate, 'UA')}
        </p>
        {data.user && (
          <p>
            <strong>
              {data.user.surname} {data.user.name}
            </strong>{' '}
            - {data.user.email}
          </p>
        )}
      </div>
    </div>
  );
};
